import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { ErrorBoundary } from 'bernie-view';

import { LocalizedText } from '@shared-ui/localization-context';
import { LodgingCompare, LodgingCompareStateProvider } from '@shared-ui/retail-lodging-lodging-compare';

import { ResultType } from 'constants/resultType';

import { UitkLayoutFlex } from 'uitk-react-layout-flex';
import { UitkSecondaryButton } from 'uitk-react-button';
import { UitkSpacing } from 'uitk-react-spacing';

import { PropertyListingWrapper } from '../property-listing/property-listing-wrapper';

const ButtonTracked = ClickTracker(UitkSecondaryButton);

export const PropertySearchListings = inject('searchResults')(
  observer(({ searchResults, handleShowMore }) => {
    const shouldDisplayShowMoreButton = searchResults.hotelsMaxDisplay < searchResults.properties?.length;
    const loadMoreRfrr = `:LoadMore${searchResults.getPageLoadNumber()}`;

    const searchResultsProperties = React.useMemo(
      () =>
        searchResults.propertySearchListings.filter(listing => listing.resultType === ResultType.LODGING_CARD).map(({ model }) => model),
      [searchResults.propertySearchListings]
    );

    return (
      <div data-stid="section-results">
        <LodgingCompareStateProvider searchResultsProperties={searchResultsProperties}>
          <PropertyListingWrapper />
          <LodgingCompare />
        </LodgingCompareStateProvider>
        {shouldDisplayShowMoreButton && (
          <ShowMoreButton
            onClickHandler={handleShowMore}
            rfrr={loadMoreRfrr}
            linkName="Show more results"
            isLoading={searchResults.isLoading}
          >
            <LocalizedText message="hotels.searchResults.paginationButton.label" />
          </ShowMoreButton>
        )}
      </div>
    );
  })
);

const ShowMoreButton = ({ onClickHandler, isLoading, rfrr, linkName, ...rest }) => (
  <ErrorBoundary label="hotel.search.showMoreResultsButton">
    <UitkSpacing padding={{ blockstart: 'three' }}>
      <UitkLayoutFlex justifyContent="center" tag="section">
        <ButtonTracked
          disabled={isLoading}
          data-stid="show-more-results"
          onClick={onClickHandler}
          rfrr={rfrr}
          linkName={linkName}
          {...rest}
        />
      </UitkLayoutFlex>
    </UitkSpacing>
  </ErrorBoundary>
);
